import * as types from './actionTypes';
import {apiRequest, apiPost, apiDelete} from '../utils/request';
import {toastr} from 'react-redux-toastr';
import { getErrorMessage } from '../utils/lib';

export function loadClientsSuccess(clients){
  return {type: types.LOAD_CLIENTS_SUCCESS, clients};
}

export function saveClientSuccess(client, isNew) {
  return {
    type: types.SAVE_CLIENT_SUCCESS,
    client,
    isNew
  };
}

export function savingClient(client) {
  return {
    type: types.SAVE_CLIENT_SAVING,
    saveInfo: {
      client,
      saving: true,
      saved: false,
      isNew: false,
    }
  };
}

export function deleteClientSuccess(client){
  return {type: types.DELETE_CLIENT_SUCCESS, client};
}

export function saveClientError(saveError){
  return {type: types.SAVE_CLIENT_ERROR, saveError};
}

export function loadClients(name, clear=false, showAll=false, isRebate=null, excludeInactive=false) {
  return function (dispatch) {
    if (!clear) {
      dispatch(loadClientsSuccess({loaded: false, items: []}));
      return apiRequest(`/api/clients?name=${name}&showAll=${showAll}&isRebate=${isRebate}&excludeInactive=${excludeInactive}`)
        .then(x => {
          if (x.error || x.data.Message) {
            toastr.error(`Error while fetching clients, error: ${x.error ? x.error : x.data.Message}`);
            return dispatch(loadClientsSuccess({loaded: true, items: []}));
          } else {
            return dispatch(loadClientsSuccess({loaded: true, items: Array.from(x.data)}));
          }
        });
    } else {
     return dispatch(loadClientsSuccess({loaded: true, items: []}));
    }
  };
}

export function loadClientsBySearch(name, clear=false, excludeInactive=false) {
    return function (dispatch) {
        if (!clear) {
            dispatch(loadClientsSuccess({loaded: false, items: []}));
            return apiRequest(`/api/clients/search?name=${name}&excludeInactive=${excludeInactive}`)
                .then(x => {
                    if (x.error || x.data.Message) {
                        toastr.error(`Error while fetching clients, error: ${x.error ? x.error : x.data.Message}`);
                        return dispatch(loadClientsSuccess({loaded: true, items: []}));
                    } else {
                        return dispatch(loadClientsSuccess({loaded: true, items: Array.from(x.data)}));
                    }
                });
        } else {
            return dispatch(loadClientsSuccess({loaded: true, items: []}));
        }
    };
}


export function saveClient(client) {
  return function (dispatch) {
    let isNew = client.id < 0;
    toastr.success('Saving Client');
    dispatch(savingClient(client));
    return apiPost(`/api/clients/${client.id}`, client)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(getErrorMessage({x}));
          dispatch(saveClientError({error: getErrorMessage({x}), client}));
        } else {
          dispatch(saveClientSuccess(x.data, isNew));
        }
      });
  };
}


export function deleteClient(client) {
  return function (dispatch) {
    toastr.success('Removing client');
    return apiDelete(`/api/clients/${client.id}`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error deleting client, error: ${x.error ? x.error : x.data.Message}`);
        } else {
          dispatch(deleteClientSuccess(client));
        }
      });
  };
}


export function unLinkMyob({id, isClient, payLoad={}}) {
  return function () {
    return apiPost(`/api/clients/myob/unlink-supplier?id=${id}&isClient=${isClient}`, payLoad)
      .then(x => {
        if (x.error || x.data.Message) {
          let message = `Error: ${x.error ? x.error : x.data.Message}`;
          toastr.error(message);
        }
        return x;
      });
  };
}
